var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center margin-top-20 margin-bottom-20",class:{ invisible: !_vm.loading }},[_c('loader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }